// Direct Vonage SMS API implementation using fetch
// This uses the REST API endpoint directly which is more browser-friendly

// Your phone number to receive notifications
const ADMIN_PHONE_NUMBER = "447713764335";

/**
 * Sends an SMS notification for a new order
 * @param orderId - The ID of the order
 * @param totalAmount - Total amount of the order
 * @param items - Number of items in the order
 * @returns Promise resolving to success status
 */
export const sendOrderConfirmationSMS = async (orderId: string | number, totalAmount: number, items: number): Promise<boolean> => {
  try {
    const apiKey = import.meta.env.VITE_VONAGE_API_KEY;
    const apiSecret = import.meta.env.VITE_VONAGE_API_SECRET;
    
    if (!apiKey || !apiSecret) {
      console.error('Vonage API credentials missing');
      return false;
    }
    
    // Format the message
    const message = `New BVG order #${orderId} placed! Total: £${totalAmount.toFixed(2)}, Items: ${items}`;
    
    // Create form data for the request
    const formData = new URLSearchParams();
    formData.append('from', 'BVG Store');
    formData.append('text', message);
    formData.append('to', ADMIN_PHONE_NUMBER);
    formData.append('api_key', apiKey);
    formData.append('api_secret', apiSecret);
    
    // Send the request to Vonage API
    const response = await fetch('https://rest.nexmo.com/sms/json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData,
    });
    
    const data = await response.json();
    console.log('SMS API response:', data);
    
    // Check if the message was sent successfully
    if (data.messages && data.messages[0].status === '0') {
      console.log('SMS sent successfully to', ADMIN_PHONE_NUMBER);
      return true;
    } else {
      console.error('SMS sending failed:', data);
      return false;
    }
  } catch (error) {
    console.error('Error sending SMS:', error);
    return false;
  }
}; 